import { toast } from "react-toastify";
import { URL } from "../common/url";
import api from "../common/api";
import {
  LOADING,
  DELIVERY_LOGIN,
  DELIVERY_PROFILE,
  ASSIGNED_ORDER_LIST,
  ATTENDANCE_STATUS,
} from "../common/constant";

const loading = (data) => {
  return { type: LOADING, payload: data };
};

const deliveryLoginAction = (data) => {
  return { type: DELIVERY_LOGIN, payload: data };
};

const deliveryProfileAction = (data) => {
  return { type: DELIVERY_PROFILE, payload: data };
};

const assignedOrderListAction = (data) => {
  return { type: ASSIGNED_ORDER_LIST, payload: data };
};

const attendanceStatusAction = (data) => {
  return { type: ATTENDANCE_STATUS, payload: data };
};

export const signinDeliveryPartner = (data, history) => {
  return async (dispatch) => {
    try {
      dispatch(loading(true));
      const response = await api.post(`${URL.signinDeliveryPartner}`, data);
      if (response?.data?.success) {
        toast.success(response?.data?.message);
        localStorage.setItem("delivery_token", response?.data?.api_token);
        localStorage.setItem(
          "delivery_user",
          JSON.stringify(response?.data?.data)
        );
        setTimeout(() => history("/dashboard"), 500);
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      toast.error(error?.response?.data?.message);
    }
  };
};

export const getDeliveryPartnerProfile = (data, history) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("delivery_token");
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await api.get(
        `${URL.getDeliveryPartnerProfile}`,
        config
      );
      if (response?.data?.success) {
        localStorage.setItem(
          "delivery_user",
          JSON.stringify(response?.data?.data)
        );
        dispatch(deliveryProfileAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
    }
  };
};

export const getAssignedOrderList = (data, history) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("delivery_token");
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await api.get(
        `${URL.getAssignedOrderList}/${data}`,
        config
      );
      if (response?.data?.success) {
        dispatch(
          assignedOrderListAction({
            data: response?.data?.data,
            summary: response?.data?.summary,
          })
        );
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
    }
  };
};

export const updateAssignmentStatus = (data, history) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("delivery_token");
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await api.post(
        `${URL.updateAssignmentStatus}`,
        data,
        config
      );
      if (response?.data?.success) {
        toast.success(response?.data?.message);
        dispatch(
          assignedOrderListAction({
            data: response?.data?.data,
            summary: response?.data?.summary,
          })
        );
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      toast.error(error?.response?.data?.message);
    }
  };
};

export const markAttendanceIn = (data, history) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("delivery_token");
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await api.post(
        `${URL.markAttendanceIn}`,
        data,
        config
      );
      if (response?.data?.success) {
        toast.success(response?.data?.message);
        dispatch(attendanceStatusAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      toast.error(error?.response?.data?.message);
    }
  };
};

export const markAttendanceOut = (data, history) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("delivery_token");
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await api.post(
        `${URL.markAttendanceOut}`,
        data,
        config
      );
      if (response?.data?.success) {
        toast.success(response?.data?.message);
        dispatch(attendanceStatusAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
      toast.error(error?.response?.data?.message);
    }
  };
};

export const getAttendanceStatus = (data, history) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("delivery_token");
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await api.get(
        `${URL.getAttendanceStatus}`,
        config
      );
      if (response?.data?.success) {
        dispatch(attendanceStatusAction(response?.data?.data));
      } else {
        toast.error(response?.data?.message);
      }
      dispatch(loading(false));
    } catch (error) {
      dispatch(loading(false));
    }
  };
};